export const BASE_URL = import.meta.env.VITE_API_BASE_URL;
export const MODE = import.meta.env.VITE_MODE ?? "";
export const GOOGLE_MAPS_API_KEY = import.meta.env.VITE_GOOGLE_MAPS_API_KEY;
export const GOOGLE_RECAPTCHA_V3_SITE_KEY = import.meta.env
  .VITE_GOOGLE_RECAPTCHA_V3_SITE_KEY;
export const GOOGLE_RECAPTCHA_V2_SITE_KEY = import.meta.env
  .VITE_GOOGLE_RECAPTCHA_V2_SITE_KEY;
export const GOOGLE_ANALYTICS_KEY = import.meta.env.VITE_GOOGLE_ANALYTICS_KEY;
export const FIREBASE_API_KEY = import.meta.env.VITE_FIREBASE_API_KEY ?? "";
export const FIREBASE_AUTH_DOMAIN =
  import.meta.env.VITE_FIREBASE_AUTH_DOMAIN ?? "";
export const FIREBASE_PROJECT_ID =
  import.meta.env.VITE_FIREBASE_PROJECT_ID ?? "";
export const FIREBASE_STORAGE_BUCKET =
  import.meta.env.VITE_FIREBASE_STORAGE_BUCKET ?? "";
export const FIREBASE_MESSAGING_SENDER_ID =
  import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID ?? "";
export const FIREBASE_APP_ID = import.meta.env.VITE_FIREBASE_APP_ID ?? "";
export const FIREBASE_VAPID_KEY = import.meta.env.VITE_FIREBASE_VAPID_KEY ?? "";
export const FIREBASE_MEASUREMENT_ID =
  import.meta.env.VITE_FIREBASE_MEASUREMENT_ID ?? "";
export const BOOKING_CALENDAR_LICENSE_KEY =
  import.meta.env.VITE_BOOKING_CALENDAR_LICENSE_KEY ?? "";
export const POSTHOG_ENABLED =
  import.meta.env.VITE_POSTHOG_ENABLED === "true" ||
  import.meta.env.VITE_POSTHOG_ENABLED === "1";

const isPlaceholder = (val?: string): boolean =>
  !val ||
  typeof val !== "string" ||
  val.trim() === "" ||
  val.startsWith("{{") ||
  val.includes("availioapp--");

export const POSTHOG_PROJECT_TOKEN =
  import.meta.env.VITE_POSTHOG_PROJECT_TOKEN ?? "";

export const POSTHOG_ACTIVE =
  POSTHOG_ENABLED && !isPlaceholder(POSTHOG_PROJECT_TOKEN);

const rawHost = import.meta.env.VITE_POSTHOG_HOST ?? "";
export const POSTHOG_HOST = !isPlaceholder(rawHost)
  ? rawHost
  : "https://eu.i.posthog.com";

const rawDefaults = import.meta.env.VITE_POSTHOG_DEFAULTS ?? "";
export const POSTHOG_DEFAULTS = !isPlaceholder(rawDefaults)
  ? rawDefaults
  : "2026-05-30";
